
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.07 4.63c-.1 2.25-1.67 5.33-4.71 9.24-3.14 4.09-5.8 6.13-7.98 6.13-1.36 0-2.48-1.25-3.42-3.73L5.12 9.42C4.43 6.93 3.69 5.69 2.9 5.69c-.66.27-1.27.64-1.81 1.09L0 5.38c1.13-.99 2.26-2 3.37-3.01C4.89 1.05 6.03.36 6.79.29c1.8-.17 2.9 1.06 3.31 3.69.45 2.84.76 4.61.93 5.3.52 2.36 1.09 3.53 1.71 3.53.48 0 1.21-.76 2.18-2.29a9 9 0 001.55-3.49c.14-1.32-.38-1.98-1.55-1.98-.59 0-1.17.13-1.71.38 1.14-3.72 3.3-5.54 6.5-5.43 2.38.06 3.49 1.6 3.36 4.61v.02z","fill":"#1F4053"}})])
          )
        }
      }
    